'use strict';

module.exports = function(Chart) {
	Chart.Scatter = function(context, config) {
		config.type = 'scatter';
		return new Chart(context, config);
	};
};



//////////////////
// WEBPACK FOOTER
// ./~/chart.js/src/charts/Chart.Scatter.js
// module id = 875
// module chunks = 0